import React from "react";
import "./Results.css";

const stats = [
  { number: "300%", label: "Traffic Growth", icon: "🚀" },
  { number: "150+", label: "Leads Generated", icon: "🎯" },
  { number: "40+", label: "Projects Done", icon: "💼" },
  { number: "4X", label: "Client ROI", icon: "💎" }
];

function Results() {
  return (
    <section className="results-section" id="results">
      <div className="results-container" data-aos="fade-up">
        <div className="results-header">
          <span className="accent-tag">Impact Metrics</span>
          <h2>Proven <span className="highlight">Results</span></h2>
          <p className="results-subtitle">
            Our data-driven approach translates into real-world growth and significant returns for our partners.
          </p>
        </div>

        <div className="results-grid">
          {stats.map((stat, index) => (
            <div 
              className="stat-card" 
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-content">
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
              <div className="stat-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Results;